import React, { useEffect } from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useProfileImportStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/stores';
import { DEFAULT_NEW_PROFILE } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Profile/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import {
  BaseSettingsForm,
  BaseSettingsFormSchema
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/types/profileTypes';
import ContentGenerationForm from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/ContentGenerationForm';
import { fetchUserTeam } from 'src/store/modules/user/operations';
import { useAppDispatch } from 'src/utils/Hooks/typedHooks';

const ProductContentGenProfile = () => {
  const { importedProfile } = useProfileImportStore();
  const dispatch = useAppDispatch();

  const methods = useForm<BaseSettingsForm>({
    mode: 'all',
    resolver: zodResolver(BaseSettingsFormSchema),
    defaultValues: {
      settings: importedProfile ? importedProfile?.settings : DEFAULT_NEW_PROFILE.settings
    }
  });

  useEffect(() => {
    if (importedProfile) {
      const newFormProfile = {
        settings: importedProfile?.settings
      };
      methods.reset(newFormProfile);
    }
  }, [importedProfile, methods]);

  useEffect(() => {
    dispatch(fetchUserTeam('/api/user/GetAllUsers'));
  }, [dispatch]);

  return (
    <Flex flexDirection="column">
      <FormProvider {...methods}>
        <ContentGenerationForm />
      </FormProvider>
    </Flex>
  );
};

export default ProductContentGenProfile;
